import React from 'react';
import PropTypes from 'prop-types';
import {Rating} from '@mui/material';

const FiveStar = (props) => {
  const handleChange = (event, value) => {
    if (props.onChange) {
      props.onChange(value);
    }
  };
  return (
    <Rating {...props} onChange={handleChange} />
  );
};

FiveStar.propTypes = {
  onChange: PropTypes.func,
};

export default React.memo(FiveStar);
